var map = {
	"./lieferando.png": 56009,
	"./wgs-payback-logo.png": 20709,
	"./zalando-de-CH.png": 24168,
	"./zalando-en-CH.png": 7923,
	"./zalando-fr-CH.png": 51323,
	"./zalando-it-CH.png": 48225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70454;